"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateState = exports.selectTrainingJobUsername = exports.selectModelDeployed = exports.selectModelFailedTraining = exports.selectModelSucceededTraining = exports.selectModelTraining = exports.selectModelObjectivesDefined = exports.selectJob = exports.selectModelVersion = exports.selectLatestDeployment = exports.selectDeployedVersion = exports.selectModelLoadStatus = exports.selectModel = exports.setInitialSubspaceReducer = exports.calculateInitialSubspace = exports.setInitialSubspace = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var tag_typescript_client_1 = require("@tableau/tag-typescript-client");
var Utils_1 = require("../../util/Utils");
var SubspaceSlice_1 = require("../slice/SubspaceSlice");
var PredictiveModelThunk_1 = require("../thunk/PredictiveModelThunk");
var EditorStateManager_1 = require("./EditorStateManager");
var initialState = __assign(__assign({}, EditorStateManager_1.prometheusEditorInitialState), { model: {
        createdAt: '',
        updatedAt: '',
        name: '',
        description: '',
        id: '',
        luid: '',
        ownerId: '',
        containerName: '',
        activeVersion: {
            updatedAt: '',
            createdAt: '',
            name: '',
            description: '',
            id: '',
            luid: '',
            lockVersion: 0,
            predictiveModelId: 0,
            versionNumber: '',
            flowId: '',
            objectiveTargetField: '',
            objectiveTargetFieldType: '',
            objectiveGoal: '',
            objectiveSuccessValue: '',
            objectiveFailureValue: '',
            objectiveAlgorithm: '',
        },
    }, job: {
        updatedAt: '',
        createdAt: '',
        id: 0,
        luid: '',
        credentialId: '',
        salesforceUserId: '',
        siteId: 0,
        siteLuid: '',
        jobOwnerId: 0,
        jobOwnerLuid: '',
        predictiveModelVersionId: 0,
        shouldCancel: false,
        transferProgress: 0,
        transferError: '',
        trainingProgress: 0,
        trainingError: '',
        transferStatus: '',
        trainingStatus: '',
        einsteinDatasetId: '',
        einsteinDatasetVersionId: '',
        einsteinStoryId: '',
        einsteinRunId: '',
        einsteinModelId: '',
        jobStart: '',
        jobEnd: '',
    }, getDraftIDResponse: {
        currentDraftID: '',
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, loadResponse: {
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, updateResponse: {
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, setNameResponse: {
        previousName: '',
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, moveModelResponse: {
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, getDeployedVersionResponse: {
        deployedVersion: undefined,
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, getLatestDeploymentByVersionLuidResponse: {
        latestDeployment: undefined,
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, recordDeploymentResponse: {
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, getNextModelVersionResponse: {
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, getRecentTrainingJobResponse: {
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    }, getUserNamesResponse: {
        trainingJobUsername: '',
        status: Utils_1.REDUX_STATUS.idle,
        error: '',
    } });
var predictiveModelSlice = (0, toolkit_1.createSlice)({
    name: 'predictiveModel',
    initialState: initialState,
    reducers: {
        updateState: function (state, action) {
            (0, EditorStateManager_1.updatePrometheusEditorState)(state, action.payload);
        },
    },
    extraReducers: function (builder) {
        (0, PredictiveModelThunk_1.getCreateModelReducers)(builder);
        (0, PredictiveModelThunk_1.getEditModelReducers)(builder);
        (0, PredictiveModelThunk_1.getSetModelNameReducers)(builder);
        (0, PredictiveModelThunk_1.moveModelReducers)(builder);
        (0, PredictiveModelThunk_1.getDraftIDReducers)(builder);
        (0, PredictiveModelThunk_1.getDeployedVersionReducers)(builder);
        (0, PredictiveModelThunk_1.getLatestDeploymentByVersionLuidReducers)(builder);
        (0, PredictiveModelThunk_1.recordDeploymentReducers)(builder);
        (0, PredictiveModelThunk_1.getUpdateModelReducers)(builder);
        (0, PredictiveModelThunk_1.getNextModelVersionReducers)(builder);
        (0, exports.setInitialSubspaceReducer)(builder);
        (0, PredictiveModelThunk_1.getRecentTrainingJobReducers)(builder);
        (0, PredictiveModelThunk_1.getUserNamesReducer)(builder);
    },
});
// Calcuation of inital subspace
exports.setInitialSubspace = (0, toolkit_1.createAsyncThunk)('SET_INITIAL_SUBSPACE', function (_, thunkAPI) {
    var state = thunkAPI.getState();
    var dispatch = thunkAPI.dispatch;
    var subspace = (0, exports.calculateInitialSubspace)(state);
    dispatch((0, SubspaceSlice_1.setSubspace)(subspace));
    return Promise.resolve(subspace);
});
var calculateInitialSubspace = function (state) {
    if ((0, exports.selectModelSucceededTraining)(state)) {
        return Utils_1.SubspaceType.Results;
    }
    if ((0, exports.selectModelTraining)(state) || (0, exports.selectModelFailedTraining)(state)) {
        return Utils_1.SubspaceType.Train;
    }
    if ((0, exports.selectModelDeployed)(state)) {
        return Utils_1.SubspaceType.Deploy;
    }
    if ((0, exports.selectModelObjectivesDefined)(state)) {
        return Utils_1.SubspaceType.Define;
    }
    return Utils_1.SubspaceType.Connect;
};
exports.calculateInitialSubspace = calculateInitialSubspace;
// Plumbing for setInitialSubspace
var setInitialSubspaceReducer = function (builder) {
    builder.addCase(exports.setInitialSubspace.fulfilled, function () {
        // Noop
    });
};
exports.setInitialSubspaceReducer = setInitialSubspaceReducer;
// Selectors
var selectModel = function (state) { return state.predictiveModel.model; };
exports.selectModel = selectModel;
var selectModelLoadStatus = function (state) { return state.predictiveModel.loadResponse; };
exports.selectModelLoadStatus = selectModelLoadStatus;
var selectDeployedVersion = function (state) { return state.predictiveModel.getDeployedVersionResponse; };
exports.selectDeployedVersion = selectDeployedVersion;
var selectLatestDeployment = function (state) { return state.predictiveModel.getLatestDeploymentByVersionLuidResponse; };
exports.selectLatestDeployment = selectLatestDeployment;
var selectModelVersion = function (state) { return state.predictiveModel.model.activeVersion; };
exports.selectModelVersion = selectModelVersion;
var selectJob = function (state) { return state.predictiveModel.job; };
exports.selectJob = selectJob;
// TODO These more complex selectors should get memoized using createSelector
var selectModelObjectivesDefined = function (state) {
    return state.predictiveModel.model.activeVersion.objectiveTargetField ? true : false;
};
exports.selectModelObjectivesDefined = selectModelObjectivesDefined;
var selectModelTraining = function (state) {
    if (!state.predictiveModel.job.id || state.predictiveModel.job.shouldCancel) {
        return false;
    }
    if (state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.InProgress ||
        state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferPending ||
        state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferUndefined) {
        return true;
    }
    if (state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferCancelled ||
        state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferFailed) {
        return false;
    }
    if (!(state.predictiveModel.job.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainSuccess ||
        state.predictiveModel.job.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainFailed ||
        state.predictiveModel.job.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainTimedOut)) {
        return true;
    }
    return false;
};
exports.selectModelTraining = selectModelTraining;
var selectModelSucceededTraining = function (state) {
    return Boolean(state.predictiveModel.job.id) && state.predictiveModel.job.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainSuccess;
};
exports.selectModelSucceededTraining = selectModelSucceededTraining;
var selectModelFailedTraining = function (state) {
    return (Boolean(state.predictiveModel.job.id) &&
        (state.predictiveModel.job.shouldCancel ||
            state.predictiveModel.job.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainFailed ||
            state.predictiveModel.job.trainingStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTrainStatusEnum.TrainTimedOut ||
            state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferCancelled ||
            state.predictiveModel.job.transferStatus === tag_typescript_client_1.TableauPredictivemodelcontrollerV1GetTransferAndTrainStatusResponseTransferStatusEnum.TransferFailed));
};
exports.selectModelFailedTraining = selectModelFailedTraining;
// TODO For now were just basing this on deployed version. Perhaps we should also take latest deployment into consideration?
var selectModelDeployed = function (state) { return (state.predictiveModel.getDeployedVersionResponse.deployedVersion ? true : false); };
exports.selectModelDeployed = selectModelDeployed;
var selectTrainingJobUsername = function (state) { return state.predictiveModel.getUserNamesResponse.trainingJobUsername; };
exports.selectTrainingJobUsername = selectTrainingJobUsername;
exports.updateState = predictiveModelSlice.actions.updateState;
exports.default = predictiveModelSlice.reducer;
//# sourceMappingURL=PredictiveModelSlice.js.map